"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translationsLibraryImports_1 = require("./translationsLibraryImports");
var UseTranslation = function () {
    var intl = (0, translationsLibraryImports_1.useIntl)();
    return intl.formatMessage;
};
exports.default = UseTranslation;
